import { useMemo } from "react";
import getSelectableOptions from "./utils/getSelectableOptions";

const useProductSelectableOptions = (product) => {
  const { options, configurations } = product || {};
  return useMemo(
    () => getSelectableOptions(options, configurations),
    [options, configurations]
  );
};

export default useProductSelectableOptions;
